import { types } from "../types/types";
import { fetchConToken } from '../helpers/fetch';
import { openModalBottom } from './ui';

export const startLoadingSmsLogs = (page = 1, size = 20, filters = {}) => {
    return async (dispatch) => {
        try {
            const queryParams = new URLSearchParams({
                pagina: page.toString(),
                limite: size.toString(),
                ...filters
            });
            
            const resp = await fetchConToken(`sms/logs?${queryParams.toString()}`);
            const body = await resp.json();
            
            if (body.ok) {
                dispatch(setSmsLogs(body.logs, body.total));
            } else {
                dispatch(openModalBottom({ 
                    text: ['Error al cargar logs de SMS'], 
                    timeOut: 3 
                }));
            }
        } catch (error) {
            console.log('Error cargando logs SMS:', error);
            dispatch(openModalBottom({ 
                text: ['Error al cargar logs de SMS'], 
                timeOut: 3 
            }));
        }
    }
};

export const startLoadingSmsStats = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('sms/estadisticas');
            const body = await resp.json();
            
            if (body.ok) {
                dispatch(setSmsStats(body.estadisticas));
            }
        } catch (error) {
            console.log('Error cargando estadísticas SMS:', error);
        }
    }
};

export const setSmsLogs = (logs, total = 0) => ({
    type: types.smsLogsLoad,
    payload: { logs, total }
});

export const setSmsStats = (stats) => ({
    type: types.smsStatsLoad,
    payload: stats
});

export const smsLogoutCleaning = () => ({
    type: types.smsLogoutCleaning
});